import { Link, NavLink } from "react-router-dom";
import { Phone } from "lucide-react";

const nav = [
  { to: "/sell-probate-house", label: "Probate" },
  { to: "/stop-foreclosure", label: "Foreclosure" },
  { to: "/sell-inherited-house", label: "Inherited" },
  { to: "/sell-house-tax-lien", label: "Tax Liens" },
  { to: "/sell-house-as-is", label: "As-Is" },
];

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-[var(--border-soft)]" data-testid="site-header">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <img src="/logo-aspire-icon-256.png" alt="Aspire Collective Partners LLC" className="h-10 w-10 object-contain" />
          <span className="font-display text-navy text-lg sm:text-xl">Aspire Collective Partners LLC</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-7" data-testid="primary-nav">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${isActive ? "text-money" : "text-navy hover:text-money"}`
              }
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <a
          href="tel:+16149664283"
          className="hidden sm:inline-flex items-center gap-2 bg-money text-white px-4 py-2 rounded-md font-semibold hover:brightness-95 transition"
          data-testid="header-call-btn"
        >
          <Phone size={16} /> (614) 966-4283
        </a>
      </div>
    </header>
  );
}
